module.exports = __webpack_public_path__ + "img/hr-stack-inserter-hand-closed-shadow.1b0b2c70.png";